import React from "react";
import { string, shape } from "prop-types";

import ArrowLink from "../../ArrowLink/ArrowLink.jsx";

const propTypes = {
  title: string.isRequired,
  subtitle: string,
  link: shape({
    text: string,
    href: string,
  }),
};

const GlobalNavIntro = (props) => {
  const { title, subtitle, link } = props;

  return (
    <section className="global-nav-intro">
      <h2 className="global-nav-intro__title">{title}</h2>
      {subtitle && <div className="global-nav-intro__subtitle">{subtitle}</div>}
      {link?.href && (
        <div className="global-nav-intro__link">
          <a
            className="link"
            href={link.href}
            data-gtm-element={`global nav intro link for ${title}`}
          >
            {link.text}
          </a>
        </div>
      )}
    </section>
  );
};

GlobalNavIntro.propTypes = propTypes;
export default GlobalNavIntro;
